import { Controller } from "@hotwired/stimulus"
import Swal from 'sweetalert2/dist/sweetalert2'

// Connects to data-controller="error-toast"
export default class extends Controller {
  static targets = [     
    'message'
  ]

  connect() {
    console.error(this.messageTarget.innerText)
    Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: true,
      confirmButtonText: 'Dismiss',
      confirmButtonColor: '#a9afb7', // $grey-light from _variables.scss
      timer: 6000,
      icon: 'error',
      text: this.messageTarget.innerText
    })
  }
}
